export const userProfilePayload = (data, orgRole) => {
  const payload = { ...data };
  if (orgRole !== 'admin' && orgRole !== 'superuser') {
    for (const field of ['workingOn', 'pilotLevel', 'certifications', 'aircraftList', 'isInstructor', 'role', 'roleId', 'orgRole']) {
      delete payload[field];
    }
  }
  return payload;
};
